import { render, staticRenderFns } from "./OverdueInspectionDialog.vue?vue&type=template&id=c2e62560&scoped=true"
import script from "./OverdueInspectionDialog.vue?vue&type=script&lang=js"
export * from "./OverdueInspectionDialog.vue?vue&type=script&lang=js"
import style0 from "./OverdueInspectionDialog.vue?vue&type=style&index=0&id=c2e62560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e62560",
  null
  
)

export default component.exports